
export class BrowserStorage {
    private readonly isLocalStorageAvailable: boolean = typeof localStorage !== 'undefined'

    set(name: string, value: any) {
        if(this.isLocalStorageAvailable) localStorage.setItem(name, String(value))
    }

    get(name: string, defaultValue: any = null): string | null {
        if(this.isLocalStorageAvailable) return localStorage.getItem(name)
        return defaultValue
    }

    delete(name: string): void {
        if(this.isLocalStorageAvailable) localStorage.removeItem(name)
    }
}
